export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '充满想象力的奇幻世界' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的动作冒险' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松欢乐的搞笑日常' },
  { slug: 'urban', name: '都市', icon: 'ri-building-line', description: '现代都市生活百态' },
  { slug: 'historical', name: '古风', icon: 'ri-book-open-line', description: '唯美古风传奇故事' },
];

export const comics = [
  {
    id: 1,
    title: '重生之绝世医妃',
    author: '金秀雅',
    category: 'love',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20beautiful%20female%20doctor%20in%20traditional%20hanbok%20dress%20with%20long%20flowing%20hair%2C%20soft%20romantic%20atmosphere%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20delicate%20lineart%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    rating: 9.5,
    status: '连载中',
    description: '天才女医生意外穿越到古代，成为被家族抛弃的庶女。凭借精湛医术和现代知识，她一步步逆袭走上人生巅峰，同时也收获了意想不到的爱情。一场跨越时空的医者仁心之旅，一段荡气回肠的绝世之恋。',
    chapters: 128,
    views: '3,256,780',
    updateTime: '2026-08-04',
    featured: true,
    trending: 1,
  },
  {
    id: 2,
    title: '暗影猎手',
    author: '朴志勋',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20male%20hunter%20with%20dark%20cloak%20holding%20a%20mysterious%20weapon%2C%20shadowy%20dramatic%20lighting%2C%20action%20fantasy%20theme%2C%20dark%20gray%20and%20crimson%20color%20scheme%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    rating: 9.3,
    status: '连载中',
    description: '在一个被暗影生物入侵的世界，少年林寒觉醒了猎杀暗影的特殊能力。他加入猎手组织，在一次次生死战斗中成长，揭开了暗影背后隐藏的惊天秘密。',
    chapters: 96,
    views: '2,891,450',
    updateTime: '2026-08-03',
    featured: true,
    trending: 2,
  },
  {
    id: 3,
    title: '魔法学院优等生',
    author: '李恩在',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20young%20wizard%20student%20in%20magical%20academy%20uniform%20casting%20sparkling%20spells%2C%20whimsical%20fantasy%20atmosphere%2C%20blue%20and%20gold%20color%20palette%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    rating: 9.1,
    status: '连载中',
    description: '平凡少年意外收到魔法学院的录取通知书，从此踏入了一个充满魔法与奇迹的世界。在学院里他结识了各具特色的伙伴，共同面对各种挑战与冒险。',
    chapters: 85,
    views: '2,103,920',
    updateTime: '2026-08-03',
    featured: true,
    trending: 3,
  },
  {
    id: 4,
    title: '第七夜的秘密',
    author: '尹智雅',
    category: 'suspense',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20mysterious%20woman%20in%20dark%20alley%20with%20moonlight%2C%20thriller%20suspense%20atmosphere%2C%20dark%20purple%20and%20silver%20color%20scheme%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    rating: 9.4,
    status: '连载中',
    description: '一座古老公寓里，每到第七个夜晚就会发生离奇事件。新搬来的租客开始调查这些诡异现象，却发现每一件事件都和一个尘封多年的秘密有关。悬疑层层递进，真相令人震惊。',
    chapters: 72,
    views: '1,987,320',
    updateTime: '2026-08-02',
    featured: false,
    trending: 4,
  },
  {
    id: 5,
    title: '我的邻居是吸血鬼',
    author: '韩志旼',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20handsome%20vampire%20man%20and%20a%20confused%20ordinary%20girl%20in%20modern%20apartment%20setting%2C%20comedic%20romantic%20vibe%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    rating: 9.0,
    status: '连载中',
    description: '普通上班族林小暖的新邻居竟然是个活了三百年的吸血鬼！更离谱的是，这个吸血鬼不仅不吸血，还是个社恐宅男。一段爆笑又温馨的跨种族同居生活就此展开。',
    chapters: 110,
    views: '2,456,100',
    updateTime: '2026-08-04',
    featured: true,
    trending: 5,
  },
  {
    id: 6,
    title: '都市夜行录',
    author: '崔正宇',
    category: 'urban',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20young%20professional%20man%20walking%20through%20city%20streets%20at%20night%20with%20neon%20lights%2C%20modern%20urban%20drama%20vibe%2C%20cool%20gray%20and%20teal%20color%20scheme%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    rating: 8.8,
    status: '已完结',
    description: '在大城市打拼的四个年轻人的故事。白天他们在写字楼里扮演着精英角色，夜晚则卸下伪装，在城市角落寻找真实的自己。都市生活的酸甜苦辣，青春与梦想的碰撞。',
    chapters: 156,
    views: '4,123,890',
    updateTime: '2026-07-15',
    featured: false,
    trending: 6,
  },
  {
    id: 7,
    title: '凤鸣九天',
    author: '张艺琳',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20noble%20woman%20in%20elegant%20ancient%20Chinese%20style%20hanfu%20dress%20surrounded%20by%20phoenix%20feathers%2C%20ethereal%20historical%20fantasy%20vibe%2C%20warm%20gold%20and%20crimson%20color%20palette%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    rating: 9.6,
    status: '连载中',
    description: '她本是九天之上的凤族公主，却因一场天界变故坠落凡间。失去法力的她以凡人身份重新修炼，在人间历劫的过程中揭开身世之谜，最终重返九天的传奇故事。',
    chapters: 142,
    views: '3,678,200',
    updateTime: '2026-08-04',
    featured: true,
    trending: 7,
  },
  {
    id: 8,
    title: '契约恋人',
    author: '宋智恩',
    category: 'love',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20couple%20signing%20a%20contract%20with%20romantic%20tension%2C%20office%20romance%20theme%2C%20soft%20rose%20and%20ivory%20color%20scheme%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    rating: 9.2,
    status: '连载中',
    description: '为了应付家里催婚，高冷总裁和普通职员签订了一份契约恋爱协议。谁知道假戏真做，两个人在相处中逐渐产生了真实感情。从契约开始，以真心结束。',
    chapters: 88,
    views: '2,234,560',
    updateTime: '2026-08-02',
    featured: false,
    trending: 8,
  },
  {
    id: 9,
    title: '末日生存指南',
    author: '姜泰民',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20survivor%20in%20post-apocalyptic%20wasteland%20holding%20a%20makeshift%20weapon%2C%20dramatic%20survival%20theme%2C%20dusty%20brown%20and%20dark%20orange%20color%20scheme%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    rating: 9.3,
    status: '连载中',
    description: '一场突如其来的病毒席卷全球，文明崩塌，秩序瓦解。普通大学生金成浩不得不在这末日世界中挣扎求生，他能否找到生存的希望，重建属于人类的未来？',
    chapters: 67,
    views: '1,876,440',
    updateTime: '2026-08-01',
    featured: false,
    trending: 9,
  },
  {
    id: 10,
    title: '异世界食堂',
    author: '权娜拉',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20cozy%20restaurant%20with%20fantasy%20creatures%20as%20customers%2C%20warm%20food%20themed%20fantasy%2C%20golden%20yellow%20and%20warm%20brown%20color%20palette%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    rating: 9.0,
    status: '连载中',
    description: '一间神奇的食堂，门连接着不同的异世界。精灵、兽人、龙族都是这里的常客。食堂老板用美食治愈了每一位异世界来客的心灵，也串联起一个个温暖的故事。',
    chapters: 94,
    views: '1,654,320',
    updateTime: '2026-08-03',
    featured: false,
    trending: 10,
  },
  {
    id: 11,
    title: '消失的她',
    author: '刘秀贤',
    category: 'suspense',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20a%20missing%20woman%20silhouette%20with%20police%20tape%20and%20investigation%20theme%2C%20psychological%20thriller%20vibe%2C%20cold%20blue-gray%20and%20dark%20color%20scheme%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    rating: 9.5,
    status: '已完结',
    description: '完美妻子突然失踪，丈夫报警寻找。然而随着调查深入，所有人都发现，他们对这个"完美妻子"的了解几乎为零。她是天使还是恶魔？真相远比想象中更加震撼。',
    chapters: 48,
    views: '2,987,650',
    updateTime: '2026-06-20',
    featured: false,
    trending: 11,
  },
  {
    id: 12,
    title: '办公室爆笑日常',
    author: '赵允熙',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cover%20art%20of%20office%20workers%20in%20funny%20chaotic%20situations%2C%20bright%20comedic%20workplace%20theme%2C%20cheerful%20yellow%20and%20white%20color%20palette%2C%20manga%20style%20illustration%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    rating: 8.9,
    status: '连载中',
    description: '社畜们的欢乐日常！加班、摸鱼、吐槽老板、同事八卦——每一个在办公室上过班的人都能在这里找到共鸣。笑点密集，治愈你的职场疲惫。',
    chapters: 135,
    views: '2,567,890',
    updateTime: '2026-08-04',
    featured: false,
    trending: 12,
  },
];

export const chapters = [
  { id: 1, comicId: 1, number: 1, title: '第1话：穿越时空的医者', date: '2025-03-15' },
  { id: 2, comicId: 1, number: 2, title: '第2话：王府的第一个病人', date: '2025-03-22' },
  { id: 3, comicId: 1, number: 128, title: '第128话：最后的抉择', date: '2026-08-04' },
  { id: 4, comicId: 2, number: 1, title: '第1话：暗影降临', date: '2025-06-10' },
  { id: 5, comicId: 2, number: 96, title: '第96话：最终决战', date: '2026-08-03' },
  { id: 6, comicId: 3, number: 1, title: '第1话：意外的录取通知书', date: '2025-08-01' },
  { id: 7, comicId: 4, number: 1, title: '第1话：搬进7号公寓', date: '2025-09-12' },
  { id: 8, comicId: 5, number: 1, title: '第1话：奇怪的邻居', date: '2025-04-20' },
  { id: 9, comicId: 6, number: 1, title: '第1话：午夜末班车', date: '2024-11-05' },
  { id: 10, comicId: 7, number: 1, title: '第1话：九天坠落', date: '2025-01-18' },
  { id: 11, comicId: 8, number: 1, title: '第1话：一份特别的合同', date: '2025-05-25' },
  { id: 12, comicId: 9, number: 1, title: '第1话：灾难之日', date: '2025-10-08' },
];

export const banners = [
  {
    id: 1,
    title: '凤鸣九天 - 九天公主的传奇归来',
    comicId: 7,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20banner%20art%20of%20a%20celestial%20phoenix%20princess%20in%20ancient%20Chinese%20style%20dress%20with%20golden%20wings%20against%20a%20starry%20night%20sky%2C%20epic%20fantasy%20atmosphere%2C%20warm%20golden%20and%20red%20tones%2C%20dramatic%20composition%2C%20digital%20art&width=1200&height=500&seq=banner-01&orientation=landscape',
    tag: '本周热门',
  },
  {
    id: 2,
    title: '重生之绝世医妃 - 逆袭之路开启',
    comicId: 1,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20banner%20art%20of%20a%20graceful%20female%20doctor%20in%20traditional%20hanbok%20with%20medical%20herbs%20and%20ancient%20palace%20background%2C%20romantic%20historical%20drama%20vibe%2C%20soft%20pink%20and%20golden%20tones%2C%20digital%20art&width=1200&height=500&seq=banner-02&orientation=landscape',
    tag: '强力推荐',
  },
  {
    id: 3,
    title: '暗影猎手 - 新篇章开启',
    comicId: 2,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20banner%20art%20of%20a%20shadow%20hunter%20in%20action%20pose%20with%20dark%20energy%20effects%2C%20action%20fantasy%20theme%2C%20dramatic%20lighting%20with%20crimson%20and%20black%20tones%2C%20digital%20art&width=1200&height=500&seq=banner-03&orientation=landscape',
    tag: '新番上线',
  },
];

export const siteInfo = {
  name: '51漫画网',
  slogan: '韩漫免费阅读，下拉式全集尽在掌握',
  description: '51漫画网是国内领先的韩国漫画免费在线阅读平台，提供海量韩漫资源。我们致力于为广大漫画爱好者提供流畅的下拉式阅读体验，涵盖恋爱、奇幻、动作、悬疑、搞笑、都市、古风等多种类型，持续更新最新韩漫章节。无需注册、完全免费，让每一位读者都能畅享精彩韩漫世界。',
  contact: {
    email: 'contact@51manhua.com',
    wechat: '51漫画网',
    weibo: '@51漫画网官方',
  },
  stats: {
    totalComics: '50,000+',
    dailyUpdate: '300+',
    registeredUsers: '8,000,000+',
    monthlyActive: '12,000,000+',
  },
};